/* eslint-disable @typescript-eslint/no-empty-function */
import { CloseIcon } from 'assets/icons/CloseIcon'
import { DashboardCard, P } from 'styling/GlobalStyles'
import { IWidget } from 'types/dashboard.interface'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { WidgetHeader, WidgetTitle } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { WidgetBody } from 'pages/HrDashboard/hrLayout.styled'
import { HrWidgetBody } from 'pages/HrDashboard/Widgets/HrWidgetBody'

export const HrAlertsAndRequestsDashboardWidget = ({
  modalOpen,
  removeWidget,
  onDragOver,
  onDragStart,
  onDragDrop,
}: IWidget) => {
  return (
    <DashboardCard
      glow
      draggable={modalOpen}
      onDragStartCapture={() => onDragStart('hr-alerts', 1)}
      onDrop={onDragDrop}
      onDragEnd={(e) => e.preventDefault()}
      onDragOver={(e) => {
        e.preventDefault()
        onDragOver('hr-alerts')
      }}
      width='1fr'
      style={{ gridArea: 'hr-alerts', cursor: modalOpen ? 'grab' : 'normal' }}
    >
      {modalOpen && (
        <WidgetEditOverlay
          onClick={(e) => {
            removeWidget('hr-alerts')
            e.stopPropagation()
          }}
        >
          <P>Remove Widget</P>
          <CloseIcon />
        </WidgetEditOverlay>
      )}
      <WidgetHeader>
        <WidgetTitle>Alerts and Notifications</WidgetTitle>
      </WidgetHeader>
      <WidgetBody>
        <HrWidgetBody type='alerts' />
      </WidgetBody>
    </DashboardCard>
  )
}
